import Box from '@mui/material/Box';
import { CustomerDetail } from '../../../../features/users/views/CustomerDetailsTable';
import OpenWindow from '../../../components/OpenWindow/OpenWindow';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import TextField from '@mui/material/TextField';
import SmtpSettings from './SmtpSettings';
import GmailSettings from './GMailSettings';
import Office365Settings from './Office365Settings';

type EmailSettingsProps = {
    data: CustomerDetail;
    onChange: (updatedValue: CustomerDetail) => void;
};

const EmailSettings = (props: EmailSettingsProps) => {
    const { data, onChange } = props;

    const onUpdateString = async (prop: string, value: string) => {
        const temp = structuredClone(data);
        temp[prop] = value;
        onChange(temp);
    };

    const updateEmailType = (emailType: string) => {
        onChange({ ...data, emailType: emailType, emailAddress: '' });
    };

    return (
        <Box gap={2} display="flex" flexDirection="column">
            <FormControl fullWidth size="small">
                <InputLabel id="type-label">Type</InputLabel>
                <Select
                    label="Type"
                    labelId="type-label"
                    fullWidth
                    value={data.emailType}
                    defaultValue={data.emailType}
                    onChange={(e) => updateEmailType(e.target.value)}
                >
                    <MenuItem value="NONE">None</MenuItem>
                    <MenuItem value="SMTP">SMTP</MenuItem>
                    <MenuItem value="GMAIL">GMail</MenuItem>
                    <MenuItem value="OFFICE365">Office 365</MenuItem>
                </Select>
            </FormControl>

            {data.emailType === 'SMTP' && <SmtpSettings data={data} onChange={onChange} />}
            {data.emailType === 'GMAIL' && <GmailSettings data={data} onChange={onChange} />}
            {data.emailType === 'OFFICE365' && <Office365Settings data={data} onChange={onChange} />}
        </Box>
    );
};

export default EmailSettings;
